import {RoumuLogo, TmLogo as TMLogo} from 'jbc-front/components/icons'
import styles from './Logo.scss'

export const Logo = () => <RoumuLogo className={styles.brand} />
export const TmLogo = () => <TMLogo className={styles.brand} />
